<template>
  <proa-card v-if="user" :class="['user-card text-center', { 'offline': user.meta.userPresence == 'offline' }]">
    <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" />
    <div class="display-name">{{ user.meta.displayName }}</div>
    <div v-if="handleMove" class="move-handler" @click.stop="() => {}">
      <img :src="require('@/assets/images/icons/move_handler.png')">
    </div>
    <div
      v-if="user.meta.userPresence == 'online'"
      class="presence-icon"
    >
      <user-status-icon
        :user="user"
      />
    </div>
  </proa-card>
</template>

<script>
import userStatusIcon from '@/components/atoms/ProaUserStatusIcon'
export default {
  name: 'UserCard',
  components: {
    userStatusIcon
  },
  props: {
    user: Object,
    handleMove: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.user-card {
  width: 120px;
  height: 150px;
  padding: 10px;
  margin: 2px 8px 2px 2px;
  position: relative;

  &.offline {
    opacity: 0.5;
  }

  .display-name {
    margin-top: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 12px;
  }

  .move-handler {
    position: absolute;
    top: 0;
    right: 0;
    cursor: move;
    padding: 5px;

    img {
      width: 16px !important;
      height: 16px !important;
    }
  }

  .presence-icon {
    position: absolute;
    top: 14px;
    left: 24px;
    width: 60%;
  }

}
</style>
